import { gql } from '@apollo/client';

export const SignOutQuery = gql`
  mutation SignOut {
    signOut
  }
`;
